var BANK_TRANSFER_MINIMUM_AMOUNT = 500;
export default BANK_TRANSFER_MINIMUM_AMOUNT;
